import { colors, typography } from '@mehilainen/mds-tokens';
import { focusVisible } from './shared';
// MATTI-TODO: No variants :(, cannot make large
export const getThemeTabs = (tokens) => ({
    MuiTab: {
        defaultProps: {
            disableTouchRipple: true,
        },
        styleOverrides: {
            root: {
                fontSize: tokens.uiElementTabs.fontSize,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                color: colors.Gray800,
                textTransform: 'unset',
                '&[class*="Mui-disabled"]': {
                    color: colors.Gray500, // MATTI-TODO
                },
                '& > [class*="MuiBadge-root"]': {
                    paddingRight: '14px',
                },
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { outlineOffset: '-8px', borderRadius: '18px' }),
                '& > [class*="MuiTouchRipple-root"]': {
                    display: 'none',
                },
                '&[class*="Mui-selected"]': {
                    color: colors.Gray900,
                },
            },
            textColorPrimary: {
                color: colors.Gray900,
            },
        },
    },
    MuiTabs: {
        styleOverrides: {
            indicator: {
                height: '4px',
                backgroundColor: tokens.uiElementTabs.lineColor,
            },
        },
    },
    MuiBadge: {
        styleOverrides: {
            badge: {
                fontSize: typography.baseTypography.size[200].rem,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                height: 'unset',
                padding: '4px 6px',
            },
        },
    },
});
